module.exports = __webpack_public_path__ + "static/media/googleQR.6655dd5c.svg";